<app-header-app xLink="/signup">
  <div class="flex gdpr-box">
    <payee-icon
      width="auto"
      name="gdpr"
    ></payee-icon>
  </div>
</app-header-app>
<app-form-template
  heading="{{ 'SIGNUP_FINALIZATION.COMPLETE_REGISTRATION' | translate }}"
  [formGroup]="registerForm"
  (submit)="finalizeSignup()"
>
  <input
    name="username"
    autocomplete="username"
    hidden
    [value]="email"
  />
  <div
    class="input-label"
    color="black"
  >
    {{ "SIGNUP_FINALIZATION.REGISTER_WITH_EMAIL" | translate }}&nbsp;
    <strong>{{ email }}</strong>
  </div>
  <payee-form-field width="wide">
    <span payee-label>{{ "SIGNUP_FINALIZATION.LAST_NAME" | translate }}</span>
    <!-- TODO: tooltip -->
    <input
      payee-input
      formControlName="lastName"
      data-testid="signup-last-name"
    />
    @if (lastName.dirty) {
      <ng-container payee-error>
        @if (lastName.hasError("required")) {
          <mat-error>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </mat-error>
        }
      </ng-container>
    }
  </payee-form-field>

  <payee-form-field width="wide">
    <span payee-label>{{ "SIGNUP_FINALIZATION.FIRST_NAME" | translate }}</span>
    <!-- TODO: tooltip -->
    <input
      payee-input
      formControlName="firstName"
      data-testid="signup-first-name"
    />
    @if (firstName.dirty) {
      <ng-container payee-error>
        @if (firstName.hasError("required")) {
          <mat-error>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </mat-error>
        }
      </ng-container>
    }
  </payee-form-field>

  <payee-form-field width="wide">
    <span payee-label>{{ "SIGNUP_FINALIZATION.PHONE_NUMBER" | translate }}</span>
    <payee-phone
      formControlName="phoneNumber"
      data-testid="signup-phone"
    ></payee-phone>
    @if (phoneNumber.dirty) {
      <ng-container payee-error>
        @if (phoneNumber.hasError("required")) {
          <mat-error>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </mat-error>
        }
      </ng-container>
    }
  </payee-form-field>

  <payee-password-form-field
    width="wide"
    formControlName="password"
    data-testid="signup-password"
  >
    <span payee-label>{{ "SIGNUP_FINALIZATION.PASSWORD" | translate }}</span>
    @if (password.dirty) {
      <ng-container payee-error>
        @if (password.hasError("required")) {
          <mat-error>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </mat-error>
        }
        @if (password.hasError("minlength")) {
          <mat-error>
            {{ "SIGNUP_FINALIZATION.PASSWORD_MIN_LENGTH" | translate }}
          </mat-error>
        }
      </ng-container>
    }
  </payee-password-form-field>

  <div class="newsletter-wrapper">
    <app-custom-checkbox formControlName="newsletter">
      <div
        class="input-label-small"
        color="black"
      >
        {{ "SIGNUP_FINALIZATION.NEWSLETTER_OPT_IN" | translate }}
      </div>
    </app-custom-checkbox>
    <span class="recommended-badge">{{ "SIGNUP_FINALIZATION.NEWSLETTER_RECOMMENDED" | translate }}</span>
  </div>

  <button
    payee-button
    width="wide"
    height="tall"
    data-testid="signup-finalize"
    [disabled]="loading()"
  >
    @if (!loading()) {
      <div class="flex vcenter hcenter">
        <span>{{ "SIGNUP_FINALIZATION.CONTINUE_TO_ACCOUNT" | translate }}</span>
        <payee-icon name="arrow-right-white"></payee-icon>
      </div>
    }
    @if (loading()) {
      <div class="bw-theme flex hcenter">
        <mat-progress-spinner
          color="accent"
          mode="indeterminate"
          diameter="30"
        ></mat-progress-spinner>
      </div>
    }
  </button>
</app-form-template>
